import { useEffect } from 'react'
import { getEl } from 'gyl-common/utils/element'

const OPEN_SELECTORS = '.ant-select-open,.ant-picker-focused'

const blur = () => {
    if (!document.activeElement || document.activeElement === document.body) {
        return
    }

    document.activeElement.blur()
}

export default ({ container, disabled }) => {
    const bindEvents = () => {
        const containerEl = getEl(container)

        const handler = () => {
             const allEls = containerEl.querySelectorAll(OPEN_SELECTORS)

            if(allEls?.length){
                blur()
            }
        }

        containerEl.addEventListener('scroll', handler)

        return () => {
            containerEl.removeEventListener('scroll', handler)
        }
    }

    useEffect(() => {
        if(disabled){
            return
        }

        const unbind = bindEvents()

        return () => {
            unbind()
        }
    }, [disabled])
}
